// extracted by mini-css-extract-plugin
export default {"dynamic-preannotations-control":"lsf-dynamic-preannotations-control"};
    if(module.hot) {
      // 1732531516157
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  